import { render, staticRenderFns } from "./UserResult.vue?vue&type=template&id=3a32b364&scoped=true&"
import script from "./UserResult.vue?vue&type=script&lang=js&"
export * from "./UserResult.vue?vue&type=script&lang=js&"
import style0 from "./UserResult.vue?vue&type=style&index=0&id=3a32b364&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a32b364",
  null
  
)

export default component.exports